// Approximate public map coordinates for U of T St. George campus buildings.
// Truck exact pins always take precedence over these fallback coordinates.
export const CAMPUS_LOCATION_COORDS = {
  'Sidney Smith Hall': { lat: 43.6626, lng: -79.3986 },
  'Robarts Library': { lat: 43.6645, lng: -79.3997 },
  'Bahen Centre': { lat: 43.6596, lng: -79.3975 },
  'Medical Sciences Building': { lat: 43.6609, lng: -79.3939 },
  'Hart House': { lat: 43.6637, lng: -79.3945 },
  'University College': { lat: 43.6608, lng: -79.3955 },
  'Gerstein Library': { lat: 43.6621, lng: -79.3937 },
  'Knox College': { lat: 43.6613, lng: -79.3970 },
  'Innis College': { lat: 43.6655, lng: -79.3996 },
  'New College': { lat: 43.6616, lng: -79.4006 },
};

export function campusLocationCoords(locationName) {
  return CAMPUS_LOCATION_COORDS[String(locationName || '').trim()] || null;
}
